module.exports = "/assets/data/4cf872d40811c579499f28ad726242a1-CO15.data.json";